var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3246",
    "data-name": "Rectangle 3246",
    width: 21,
    height: 19,
    transform: "translate(-2 -2)",
    fill: "#2e728c",
    stroke: "#2e728c",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11055",
    "data-name": "Group 11055",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11032",
    "data-name": "Group 11032",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29008",
    "data-name": "Path 29008",
    d: "M13.281,15h-10a.469.469,0,0,1-.469-.469V11.563H.469A.469.469,0,0,1,0,11.094V4.844A1.775,1.775,0,0,1,1.823,3.125h.99V.469A.469.469,0,0,1,3.281,0h10a.469.469,0,0,1,.469.469V3.125h.99a1.775,1.775,0,0,1,1.823,1.719v6.25a.469.469,0,0,1-.469.469H13.75v2.969a.469.469,0,0,1-.469.469M3.75,14.063h9.063V9.688H3.75Zm10-3.437h1.875V4.844a.839.839,0,0,0-.885-.781H1.823a.839.839,0,0,0-.885.781v5.781H2.813V9.219a.469.469,0,0,1,.469-.469h10a.469.469,0,0,1,.469.469Zm-10-7.5h9.063V.938H3.75Z",
    transform: "translate(0 0)",
    fill: "#2e728c",
    stroke: "#2e728c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29009",
    "data-name": "Path 29009",
    d: "M118.566,54.781a.781.781,0,1,1-.781-.781.781.781,0,0,1,.781.781",
    transform: "translate(-104.816 -48.375)",
    fill: "#2e728c",
    stroke: "#2e728c",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriterIcon);
export default __webpack_public_path__ + "static/media/priter_icon.8cc801d3f68e7f3fea551ac99ecf1318.svg";
export { ForwardRef as ReactComponent };